import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatBubbleDoubleRegular from './chat-bubble-double-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatBubbleDoubleRegular {...validProps} />;
}
SvgComponent.iconName = 'chat-bubble-double-regular';

export const ChatBubbleDoubleRegularIcon = svgIconWrapper(SvgComponent);
